
<div class="card-container flex flex-row gap-1">
  <div
    :class="['icon-container flex flex-col justify-center items-center border-transparent rounded-md', data.active ? 'bg-white' : 'bg-coverCardDeactivated']"
  >
    <div class="icon-circle flex flex-col justify-center items-center">
      <img
        v-if="!data.active"
        :class="['svg-filter-inactive']"
        :src="iconImgPath" alt="card icon"
      >
      <loading v-else :icon="data.icon" :duration="2000" />
    </div>
  </div>
  <div
    :class="['content-container w-full bg-white border-transparent rounded-md flex flex-col justify-center', data.active ? 'bg-white' : 'bg-coverCardDeactivated']"
  >
    <h1 class="pl-3 cover-card-title pb-1">{{ data.title }}</h1>
    <p class="px-3 cover-card-content text-sm">{{ data.content }}</p>
  </div>
</div>
